import { render, staticRenderFns } from "./TencentOfficeView.vue?vue&type=template&id=32df97f2&scoped=true"
import script from "./TencentOfficeView.vue?vue&type=script&lang=js"
export * from "./TencentOfficeView.vue?vue&type=script&lang=js"
import style0 from "./TencentOfficeView.vue?vue&type=style&index=0&id=32df97f2&prod&lang=scss&scoped=true"
import style1 from "./TencentOfficeView.vue?vue&type=style&index=1&id=32df97f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32df97f2",
  null
  
)

export default component.exports